import DataInFormTool from '@/components/learing-registry/data-in-form-tool/data-in-form-tool';
import IndexContent from '@/components/learing-registry/index-content/index-content';
import { learningRegistryAPI } from '@/providers/apis/learning-registry/learning-registry';
import { PERMISSION_CHECK } from '@/utils/constants';
import { Vue, Component, Prop } from 'vue-property-decorator';
import EditProduct from '@/components/learing-registry/create-product-form/create-product-form';
import CreateRegistryForm from '@/components/learing-registry/create-registry-form/create-registry-form';

@Component({
    name: 'edit-product-details',
    components: {
        'edit-tool': CreateRegistryForm,
        'edit-product': EditProduct,
        'tool-date-in': DataInFormTool,
        'index-content': IndexContent,
    },
})

export default class EditProductDetails extends Vue {


    // -----------------------------------------------------------------------
    // Properties

    @Prop()
    private toolPartners: any;

    @Prop()
    private activeToolData: any;

    private permissonCheck = PERMISSION_CHECK;

    private tabList: Array<{name: string, key: string, component: string}> = [
        {
            name: `${this.$access.isHavingPermisson(this.permissonCheck.createProduct) ? 'Edit Product' : 'Product'}`,
            key: 'product',
            component: 'edit-product',
        },
        {
            name: 'Tool / Player',
            key: 'tool',
            component: 'edit-tool',
        },  {
            name: 'Tool Data In',
            key: 'data-in',
            component: 'tool-date-in',
        },  {
            name: 'Index Content',
            key: 'index-content',
            component: 'index-content',
        },
    ];

    private activeTab: {name: string, key: string} = this.tabList[0];

    private publisherTools: any = [];

    // ------------------------------------------------------------------------------
    // Hooks

    private created() {
        this.fetchToolList();
        this.checkEditTool();
    }


    // ----------------------------------------------------------------------
    // Actions
    private onGoBack() {
        this.$router.push('/partner-catalog/content-registry');
    }


    private onChangeTab(tab: {name: string, key: string}) {
        this.activeTab = tab;
    }

    private onUpdateTool(toolData: any) {
            this.updateToolData(toolData);
    }

    private onAddPublisher(publisherInfo: any) {
        this.updatePublisherData(publisherInfo);
    }

    // ---------------------------------------------------------------------
    // Methods

    private updateToolData(toolData: any) {
        const activeToolData = this.activeToolData;
        const publisherTool = activeToolData.toolData;
        toolData.registryType = 'content_registry';
        toolData.providerId = activeToolData.id;
        toolData.isPublisher = true;
        if (this.$access.isHavingPermisson(this.permissonCheck.createProduct)) {
            if (publisherTool) {
                const toolId = publisherTool.id;
                learningRegistryAPI.updateToolsToProvider(toolData, toolId).then(() => {
                    this.$router.push('/partner-catalog/content-registry');
                });
            } else {
                this.createPublisherTool(toolData);
            }
        } else {
            this.onConfigTool(publisherTool);
        }


    }

    private onConfigTool(tool: any) {
        learningRegistryAPI.configureToolInfo(tool).then((dataInfo: any) => {
            this.$router.push('/partner-catalog/content-registry');
        });
    }

    private updatePublisherData(toolData: any) {
        learningRegistryAPI.updateProductInfo(toolData).then(() => {
            this.$router.push('/partner-catalog/content-registry');
        });
    }

    private fetchToolList() {
        if (this.$access.isHavingPermisson(this.permissonCheck.viewProduct)) {
            learningRegistryAPI.fetchTooList().then((tooList: any) => {
                this.publisherTools = tooList;
             });
        } else {
            this.fetchSubscribedTool();
        }
    }

    private createPublisherTool(toolData: any) {
        learningRegistryAPI.saveToolsToProvider(toolData).then(() => {
            this.$router.push('/partner-catalog/content-registry');
        });
    }

    private fetchSubscribedTool() {
        const params = {
            offset: 0,
            limit: 10,
            registry_type: 'tool_registry',
        };
        learningRegistryAPI.fetchSubscribedToolRegistryList(params).then((registryList: any) => {
            this.publisherTools = registryList.subscribedTools;
        });
    }

    private checkEditTool() {
        const activeToolData = this.activeToolData;
        if (!this.activeToolData) {
            this.$router.push('/partner-catalog/content-registry');
        }
    }

}
